<template>
	<div class="content">
		<div class="container-fluid">
			<div class="row">
				<div class="col-md-12">
					<div class="row">
						<div class="col-xl-12 card">
							<h3>AWS overview</h3>
							<h4 class="card-title">Total Cost for the last 12 months: {{ this.plutus_aws_costs_total }}</h4>
							<div>
								<multiselect v-model="filtered" label="name" track-by="code" :options="options" :multiple="true" :taggable="true" ></multiselect>
							</div>
							<chart-card :key='plutus_aws_costs_data' :chart-data="plutus_aws_costs_data.data"
										:chart-options="plutus_aws_costs_data.options"
										:responsive-options="plutus_aws_costs_data.responsiveOptions"
										chart-type="Bar">             
								<template slot="header">
								</template>
								<template slot="footer">
									<div class="legend">
                                        <span v-for="(service,i) in filtered">
                                          <i class="fa fa-circle" :style='{color: colors[i]}'></i>{{ service['name'] }}
                                        </span>
										<!-- <i class="fa fa-circle text-warning"></i> AWS Commitment (no VAT) -->
									</div>
								</template>
							</chart-card>
						</div>
					</div>
					<div class="row">
						<div class="col-xl-12 card">
							<div class="card-body">
								<h4 class="card-title">Cloudability Cost</h4>
								<p class="card-category">Last 12 months</p>
								<strong>{{ plutus_cloudability_costs_total }}</strong>
							</div>
							<div class="card-footer"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import ChartCard from 'src/components/Cards/ChartCard.vue'
	import StatsCard from 'src/components/Cards/StatsCard.vue'
	import LTable from 'src/components/Table.vue'
	import axios from 'axios'
	import { colors, formatMoney, formatSimple, chart_base } from 'src/globalVariables'
	import { setInterval } from 'timers';
	import Multiselect from 'vue-multiselect'


	Number.prototype.pad = function(size) {
		let s = String(this);
		while (s.length < (size || 2)) {s = "0" + s;}
		return s;
	};

	export default {
		components: {
			LTable,
			ChartCard,
			StatsCard,
			Multiselect,
		},
		async created() {
			this.accessToken = await this.$auth.getAccessToken()	
			this.options=[]
			this.filtered = [] 
			this.loadData();
			let vm = this;
			setInterval(function(){
				vm.loadData();
			},vm.refresh_minutes*60*1000);
		},
		methods: {
			loadData: function(){
				let today = new Date();
				this.last_update = today.getHours().pad(2) + ":" + today.getMinutes().pad(2) + ":" + today.getSeconds().pad(2);
				console.log('refreshing...');
				axios
					.get('payments/aws?access_token=' + this.accessToken)
					.then(response => (this.plutus_aws_costs = response.data));
			},
			refresh_plutus_aws: function() {

				let [labels, series] = [[], []];
				var vm = this
				if (this.plutus_aws_costs){
					// creating labels first to identify position for each serie
					for (let date in this.plutus_aws_costs['results']) {
						labels.push(date);
						// creating list of services
						if (this.options.length == 0){
							labels.forEach(function(date){
								vm.plutus_aws_costs['results'][date].forEach(function(svc){
									let entry = Object.entries(svc)
									if (vm.service_name.includes(entry[0][0]) == false) {
										vm.service_name.push(entry[0][0])
									}
								})
							})
						}
					}
					if (this.options.length == 0){
						vm.service_name.forEach(function(it){
							vm.options.push({code:it, name:it})
						})
						this.filtered = this.options
					}
					var vm = this;
					//initialise series with zeroes
					this.service_name.forEach(function(v,i){
						series[i] = Array(labels.length).fill(0)
					})
					var isvc =0
					//loads the series with the existing values
					labels.forEach(function(date,idate){
						vm.plutus_aws_costs['results'][date].forEach(function(v){
							let entry = Object.entries(v)
							//finding service series index based on service name
							isvc = vm.service_name.indexOf(entry[0][0])
							series[isvc][idate] = {meta:entry[0][1],value:entry[0][1]}
						})
					})
					var filtered_series = []
					this.filtered.forEach(function(v){
						isvc = vm.service_name.indexOf(v['name'])
						filtered_series.push(series[isvc])
					})
					series = filtered_series
					this.plutus_aws_costs_total = formatMoney.format(this.plutus_aws_costs['total']);
					this.plutus_cloudability_costs_total = formatMoney.format(this.plutus_aws_costs['total'] * 0.91 / 100)
					this.plutus_aws_costs_data = {
						'service_name': this.service_name,
						'data': {
							'labels': labels,
							'series': series
						},
						'options': Object.assign({}, chart_base.options),
				        'responsiveOptions': Object.assign({}, chart_base.responsiveOptions),
					}
					this.plutus_aws_costs_data.options.stackBars = true
					this.plutus_aws_costs_data.options.seriesBarWidth=30
					this.plutus_aws_costs_data.options.tooltip.tooltipOffset= {
						x: 15,
						y: 25
					}
					this.plutus_aws_costs_data.options.tooltip.tooltipFnc= function(meta, value) {
						var txt = document.createElement('textarea');
						txt.innerHTML = meta;
					return txt.value}
				}
			}

		},
		watch: {
			plutus_aws_costs:function(){
				this.refresh_plutus_aws()
			},
			filtered:function(){
				this.plutus_aws_costs_data={}
				this.refresh_plutus_aws()
			},
		},
		computed: {

		},
		data () {
			return {
				service_name:[],
				options : [],
				filtered:[],
				refresh_minutes: 30,
				last_update: '',
				colors: colors,
				plutus_aws_costs: {},
				plutus_aws_costs_total: 0,
				plutus_cloudability_costs_total: 0,
				plutus_aws_costs_data: {},
				editTooltip: 'Edit Task',
				deleteTooltip: 'Remove',
			}
		}
	}
</script>
<style>
	h4.btn {
		background-color: #343a40;
		border-color: #343a40;
		color: #FFFFFF;
	}
</style>
